// Alternative for Object.keys() that works better with type checks when a custom key type is used.
export const keys = <T extends string | number | symbol>(obj: { [key in T]?: any }): T[] =>
    Object.keys(obj) as T[]
